const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-neutral-700 p-2 border rounded shadow text-sm text-neutral-400">
        <p>{label}</p>
        <p className="flex items-center gap-2">
          <div className="h-2 w-2 bg-[#95DE64] rounded-full"></div>
          Revenus :{" "}
          <span className="text-white">
            {payload[0].value.toLocaleString("fr-FR")} €
          </span>
        </p>
      </div>
    );
  }
  return null;
};

export default CustomTooltip;
